var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "chatroom-url-modal",
      "footer-class": "d-flex justify-content-end"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('h5', {
          staticClass: "m-0 align-self-center"
        }, [_vm._v(_vm._s(_vm.title))]), _c('b-button', {
          staticClass: "text-dark",
          attrs: {
            "size": "sm",
            "variant": "link"
          },
          on: {
            "click": function click($event) {
              return close();
            }
          }
        }, [_c('svg', {
          staticStyle: {
            "height": "20px"
          },
          attrs: {
            "xmlns": "http://www.w3.org/2000/svg",
            "viewBox": "0 0 320 512"
          }
        }, [_c('path', {
          attrs: {
            "d": "M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
          }
        })])])];
      }
    }, {
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.$bvModal.hide('chatroom-url-modal');
            }
          }
        }, [_vm._v(" 關閉 ")])];
      },
      proxy: true
    }])
  }, [_c('h5', {
    staticClass: "mb-2"
  }, [_vm._v(_vm._s(_vm.label))]), _c('b-textarea', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: '已複製',
      expression: "'已複製'",
      modifiers: {
        "click": true
      }
    }],
    attrs: {
      "id": 'chatroom-url'
    },
    on: {
      "click": function click($event) {
        return _vm.copyUrl('#chatroom-url');
      }
    },
    model: {
      value: _vm.url,
      callback: function callback($$v) {
        _vm.url = $$v;
      },
      expression: "url"
    }
  }), _c('div', {
    staticClass: "d-flex flex-column align-items-center mt-3"
  }, [_c('vue-qr', {
    ref: "qrcode",
    attrs: {
      "text": _vm.url
    }
  }), _c('b-button', {
    staticClass: "center-button mt-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.downloadQRCode(_vm.$refs.qrcode, _vm.title);
      }
    }
  }, [_vm._v(" 下載QRCode ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }